<div class="ui-autocomplete-chip">
  <mat-form-field
    [ngClass]="{ 'option-inline': inlineChips }"
    class="option-chip-list w-100"
    appearance="outline"
  >
    <mat-chip-list #chipList aria-label="Chip selection">
      <mat-chip *ngFor="let option of selectedOptions" class="lum-chip">
        <div class="option-chip-list-label">
          {{ option[displayProperty] }}
        </div>
        <button matChipRemove (click)="onRemove(option)">
          <lum-ui-icon
            icon="close-circle"
            [width]="18"
            [height]="18"
            color="#000000"
          ></lum-ui-icon>
        </button>
      </mat-chip>
      <input
        class="option-input"
        [placeholder]="placeholder"
        #optionInput
        [formControl]="optionControl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="!options ? onAdd($event) : null"
      />
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete">
      <ng-container *ngIf="!loading; else loader">
        <mat-option
          *ngFor="let option of uniqueFilteredOptions; trackBy: trackByFn"
          [value]="option[displayProperty]"
          (click)="onAdd(option)"
        >
          {{ option[displayProperty] }}
        </mat-option>
      </ng-container>

      <ng-template #loader>
        <mat-option>
          <div class="flex gap-4">
            <mat-progress-spinner
              class="progress-spinner mt-3"
              diameter="24"
              mode="indeterminate"
            ></mat-progress-spinner>
            <small>Loading...</small>
          </div>
        </mat-option>
      </ng-template>
    </mat-autocomplete>
  </mat-form-field>
</div>
